import { defineMessages } from "@/i18n";
import en from "./en";

export const framesEventMessages = defineMessages("frames-event", en);
